export const endpoints = {
  adminProbe: '/admin/users',
  getApiToken: '/api/get-api-token',
  logout: '/logout', 

  getBuildingAllUsersAndContacts: '/lockdown/v3/admin/list/:buildingId/users-contacts',
  addLockdownUser: '/lockdown/v3/admin/add_user/:userContactId/permission/:permission',
  deleteLockdownUser: '/lockdown/v3/admin/delete_user/:userContactId/client/:clientId/user_type/:userType',
  getLockdownUsersForClient: '/lockdown/v3/admin/lockdown_users_for_client/:clientId',
  updateLockdownUser: '/lockdown/v3/admin/update_user/:userContactId/client/:clientId/user_type/:userType',
  getLogs:          '/lockdown/v3/admin/logs/:clientId',
  getAlerts:                  '/lockdown/v3/admin/:clientId/alerts',
  getUserStatuses:            '/lockdown/v3/admin/:clientId/user_statuses',
  getUserStatusesForAlert:    '/lockdown/v3/admin/:clientId/user_statuses/for_alert/:alertId',
  getLockdownMessages:        '/lockdown/v3/:buildingId/lockdown/list',
  getRecipientsForAlert:      '/lockdown/v3/admin/recipients_for_alert/:alertId',
};
